import React from "react";
import styled from "./Intro.module.css";
import TypeWriter from "../TypeWriter/TypeWriter";

const Intro = () => {
  return (
    <div id="intro" className={styled.wrap}>
      <p className={styled.eyebrow}>Hi, my name is</p>
      <h1 className={styled.name}>
        Md <span className={styled.accent}>Miftahul Islam</span>
      </h1>
      <p className={styled.typewriter}>
        <TypeWriter />
      </p>
      <p className={styled.bio}>
        I'm a passionate <strong>MERN Stack Developer</strong> with hands-on
        experience building scalable, production web applications. I work
        across <strong>React.js, Node.js, and Express.js</strong>, along with
        Laravel and PHP for enterprise and ERP systems, to deliver reliable,
        high-quality solutions for clients across the UAE and beyond.
      </p>

      <div className={styled.ctaRow}>
        <a
          className={styled.ctaLink}
          target="_blank"
          rel="noreferrer"
          href="https://www.linkedin.com/in/miftahul-islam-b794a817a/"
        >
          <button className={styled.btnPrimary}>Let's Chat</button>
        </a>
        <a
          className={styled.ctaLink}
          target="_blank"
          rel="noreferrer"
          href="https://drive.google.com/file/d/1z6JTckkKlm_35ERfR6AL40UduBGcM5sU/view?usp=sharing"
        >
          <button className={styled.btnGhost}>See My Resume</button>
        </a>
      </div>
    </div>
  );
};

export default Intro;
